import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { authFailCheck } from "./auth.slice";
import InstructorService from "services/InstructorService";

const instructorsAdapter = createEntityAdapter({
  selectId: (entryType) => entryType.id,
});

const instructorsSlice = createSlice({
  name: "instructors",
  initialState: instructorsAdapter.getInitialState({
    isLoading: false,
  }),
  reducers: {
    fetchRequest(state) {
      state.isLoading = true;
    },
    fetchFail(state, action) {
      state.isLoading = false;
    },
    fetchInstructorsSuccess(state, action) {
      state.isLoading = false;
      instructorsAdapter.setAll(state, action.payload);
    },
    updateInstructorSuccess(state, action) {
      state.isLoading = false;
      instructorsAdapter.upsertOne(state, action.payload);
    },
    createInstructorSuccess(state, action) {
      state.isLoading = false;
      instructorsAdapter.addOne(state, action.payload);
    },
    deleteInstructorSuccess(state, action) {
      state.isLoading = false;
      instructorsAdapter.removeOne(state, action.payload);
    },
  },
});

export const {
  fetchRequest,
  fetchFail,
  fetchInstructorsSuccess,
  updateInstructorSuccess,
  createInstructorSuccess,
  deleteInstructorSuccess,
} = instructorsSlice.actions;

export const instructorsSelectors = instructorsAdapter.getSelectors(
  (state) => state.instructors
);

export default instructorsSlice.reducer;

export const fetchInstructors = () => async (dispatch) => {
  dispatch(fetchRequest());
  const response = await InstructorService.get();
  if (response.ok) {
    dispatch(fetchInstructorsSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const updateInstructor = (instructorId, instructor) => async (
  dispatch
) => {
  dispatch(fetchRequest());

  const response = await InstructorService.update(instructorId, instructor);

  if (response.ok) {
    dispatch(updateInstructorSuccess({ id: instructorId, ...instructor }));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const createInstructor = (instructor) => async (dispatch) => {
  dispatch(fetchRequest());

  const response = await InstructorService.create(instructor);

  if (response.ok) {
    const { id } = response.data;
    dispatch(createInstructorSuccess({ id, ...instructor }));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const deleteInstructor = (instructorId) => async (
  dispatch,
  getState
) => {
  dispatch(fetchRequest());
  const response = await InstructorService.delete(instructorId);
  if (response.ok) {
    dispatch(deleteInstructorSuccess(instructorId));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};
